// see https://paper.dropbox.com/doc/Account-Profile-Implementation-Guide--BSbcg050r3jwy_wt_6oghKIaAg-Kq6xMOLN7Juezo9ofKek0
import { FeatureFlags } from "shared";
import { TagAction } from "../types/TagAction.types";
import { WindowWithOptionalUtag } from "../types/Utag.types";
import { getEnvironment } from "./getEnvironment";

const environment = getEnvironment(window.location.hostname);

const logData = (type: "link" | "view") => (data: any) => {
  if (environment === "localhost") {
    console.log(`utag ${type}`, data);
  }
};

const utagDummy = {
  link: logData("link"),
  view: logData("view"),
};

const windowWithOptionalUtag = window as unknown as WindowWithOptionalUtag;

const getUtag = () => {
  // Use the global utag if it exists, else replace with a mock implementation. This could be because
  // we're on localhost or because the user's browser is blocking the global utag.
  // Check each time instead of once at the top of the file as utag may not be loaded yet.
  const { utag = utagDummy } = windowWithOptionalUtag;
  return utag;
};

export const logClick = ({ name, action }: TagAction): void => {
  const utag = getUtag();
  utag.link({
    _tag_name: "page_interaction",
    action_name: name,
    action,
  });
};

export const logModal = (modalType: string, errorMessages?: string[]): void => {
  const utag = getUtag();
  utag.view({
    _tag_name: "modal_view",
    modal_type: modalType,
    ...(errorMessages && { error_messages: errorMessages }),
  });
};

export type OnReadyPayload = {
  featureFlags: FeatureFlags;
  emailHash: string;
  isPolicyHolder?: boolean;
  hasOutstandingBalance?: boolean;
  hasHdc?: boolean;
  hasESignDocuments?: boolean;
};

let hasLoggedOnReady = false;

export const resetLogOnReady = (): void => {
  hasLoggedOnReady = false;
};

export const logOnReady = (payload: OnReadyPayload): void => {
  if (
    hasLoggedOnReady ||
    payload.isPolicyHolder === undefined ||
    payload.hasOutstandingBalance === undefined ||
    payload.hasHdc === undefined
  ) {
    return;
  }

  hasLoggedOnReady = true;

  const utag = getUtag();
  utag.view({
    _tag_name: "account_main_page",
    user_type: "direct",
    logged_in: true,
    mobile_app: false,
    test_experience: payload.featureFlags,
    hashed_email: payload.emailHash,
    insurance_indicator: payload.isPolicyHolder,
    has_positive_bill_amount: payload.hasOutstandingBalance,
    hdc_membership: payload.hasHdc,
    has_message_displayed: payload.hasESignDocuments,
  });
};
